import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Item from '../../../components/itens/item'


function OrgaosScreen() {
    return (
        <Fragment>
            <Head titulo="Secretaria Municipal de Saúde" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <Item
                            titulo={"Unidades de Atendimento"}
                            descricao={"Veja aqui as Unidades de Atendimento de Saúde no município, seu horário de funcionamento, entre outras informações"}
                            awesome={"faHospital"}
                            link={"../transparencia/orgaos/locais/saude"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Profissionais da Saúde"}
                            descricao={"Veja aqui os profissionais que atuam na Rede Municipal de Saúde, seus horários de atendimento, entre outras informações"}
                            awesome={"faUserDoctor"}
                            link={"saude/profissionais"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Pareceres Conclusivos Conselho Municipal de Saúde"}
                            descricao={"Veja aqui o pareceres conclusivos do Conselhor Municipal de Saúde a respeito da Prestação de contas anuais"}
                            awesome={"faBookMedical"}
                            link={"saude/parecer"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Atas das Audiências Públicas"}
                            descricao={"Veja aqui as Atas das Audiências Públicas de apresentação dos Relatórios das Ações, serviços e Aplicações Financeiras em saúde"}
                            awesome={"faCommentMedical"}
                            link={"saude/atasaudiencia"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Atas do Conselho Municipal de Saúde"}
                            descricao={"Veja aqui as Atas das das reuniões do Conselho Municipal de Saúde"}
                            awesome={"faNotesMedical"}
                            link={"saude/atasconselho"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Plano Municipal de Saúde"}
                            descricao={"Veja aqui os Planos Municipais de Saúde"}
                            awesome={"faHeartPulse"}
                            link={"saude/planomunicipal"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Programação Anual da Saúde"}
                            descricao={"Veja aqui as Programações Anuais da Saúde"}
                            awesome={"faHospitalUser"}
                            link={"saude/planoanual"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Relatório Anual da Gestão de Saúde"}
                            descricao={"Veja aqui os Relatórios Anuais da Gestão de Saúde"}
                            awesome={"faBriefcaseMedical"}
                            link={"saude/relatorioanual"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"REMUME"}
                            descricao={"Veja aqui todos a Relação Municipal de Medicamentos Essenciais."}
                            awesome={"faPills"}
                            link={"saude/remume"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Coronavírus"}
                            descricao={"Acompanhe as ações de combate e prevenção da COVID-19 no município de Macuco."}
                            awesome={"faVirusCovid"}
                            link={"saude/covid"}
                            key={2}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OrgaosScreen;